import { useState } from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';

const SocialLink = ({ href, icon: Icon, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/90 hover:scale-110 transition-transform duration-300 shadow-sm"
    aria-label={label}
  >
    <Icon size={18} className="text-gray-800 md:w-5 md:h-5" />
  </a>
);

const Toast = ({ message, isVisible }) => (
  <div 
    className={`absolute -top-12 left-1/2 -translate-x-1/2 px-4 py-2 bg-black text-white rounded-full text-sm transition-all duration-300 whitespace-nowrap ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
    }`}
  >
    {message}
  </div>
);

export default function Hero() {
  const [showToast, setShowToast] = useState(false);
  const [showHoverTooltip, setShowHoverTooltip] = useState(false);
  const email = 'deepaliagrawal224@gmail.com';

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setShowHoverTooltip(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
      {/* Left Content Box */}
      <div className="relative p-6 sm:p-8 md:p-12 lg:p-16 bg-gradient-to-br from-[#f8f8f8] via-[#f0f0f0] to-[#e8f0f0] rounded-[24px] md:rounded-[32px]">
        <div className="flex flex-col h-full">
          <div className="flex-1">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-fraunces mb-4 md:mb-6 leading-[1.1] tracking-tighter text-center md:text-left">
              Hi, I am Deepali Agrawal
            </h1>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed tracking-tight text-center md:text-left mx-auto md:mx-0 max-w-[95%] md:max-w-[90%]">
              I am an illustrator based out of Bengaluru, India, where I create art that brings joy to everyday life. With a passion for both traditional and digital illustration, I spend my days crafting whimsical doodles and getting inspired by all things aesthetic – from vintage designs to modern minimalism. My work reflects the vibrant culture of my city while adding a contemporary twist to familiar themes.
            </p>
          </div>
          
          {/* Contact and Social Links */}
          <div className="mt-12 md:mt-24 flex flex-col items-center md:flex-row md:items-center gap-6 md:gap-8">
            <div className="relative">
              {/* Hover Tooltip */}
              <Toast message="Click to copy email" isVisible={showHoverTooltip && !showToast} />
              {/* Copy Confirmation Toast */}
              <Toast message="Email copied!" isVisible={showToast} />
              
              <button 
                onClick={handleCopyEmail}
                onMouseEnter={() => setShowHoverTooltip(true)}
                onMouseLeave={() => setShowHoverTooltip(false)}
                className="w-full md:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-black text-white rounded-full hover:bg-gray-800 transition-colors duration-300 text-base md:text-lg"
              >
                <Mail size={20} />
                Contact me
              </button>
            </div>
            
            <div className="flex justify-center md:justify-start gap-3 md:gap-4">
              <SocialLink 
                href="https://www.instagram.com/_orange.palette_/" 
                icon={Instagram} 
                label="Instagram"
              />
              <SocialLink 
                href="https://www.linkedin.com/in/deepali-agrawal-1910/" 
                icon={Linkedin} 
                label="LinkedIn"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Right Image Box */}
      <div className="relative rounded-[24px] md:rounded-[32px] overflow-hidden bg-amber-400/90 aspect-square md:aspect-auto">
        <img 
          src="/images/avatar.png"
          alt="Illustration"
          className="w-full h-full object-cover"
        />
        {/* Mobile Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent md:hidden"></div>
      </div>
    </div>
  );
}